import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { fetchRequestWrapper } from "@/lib/utilities";
import importBlocksAndAllocationsStore from "./importBlocksAndAllocationsStore";
import { IImportJsonBlocks } from "@/store/importBlocksAndAllocationsStore";
import tradeDataStore from "./tradeDataStore";
import { addTradeToStore } from "./tradeDataStoreACTIONS";
interface objToSendSave {
  blockIds: number[];
  expiryPeriod?: number;
  expiryPeriodType?: "seconds" | "minutes" | "hours" | "days";
}

export async function saveTradeAction(
  getAccessTokenSilently: Function,
  objToSend: objToSendSave,
  setTradeToExpanded: boolean,
) {
  const saveTradeResponse = await fetchRequestWrapper(
    {
      url: "/Trade/Execution/Save",
      method: "POST",
      objToSend: objToSend,
    },
    getAccessTokenSilently,
  );

  const incomingTrade: ExecutionStrategy = {
    status: saveTradeResponse.status,
    role: saveTradeResponse.role, // Check this.
    structureType: saveTradeResponse.structureType,
    esid: saveTradeResponse.esid,
    type: saveTradeResponse.type,
    // cp: "",
    details: saveTradeResponse.details,
    latestActivity: saveTradeResponse.latestActivity,
    actionedBy: saveTradeResponse.actionedBy,
    actionedAt: saveTradeResponse.actionedAt,
    owner: saveTradeResponse.owner,
    quoteSideES: saveTradeResponse.quoteSideES,
    strategyType: saveTradeResponse.strategyType,
    notationES: saveTradeResponse.notationES,
    indicativeMid: saveTradeResponse.indicativeMid || "",
    legs: saveTradeResponse.legs,
    originatingCounterparty: saveTradeResponse.originatingCounterparty,
  };

  const currentEsidsToFlash = tradeDataStore.getState().eisdsToFlash;
  setTimeout(() => {
    tradeDataStore
      .getState()
      .updateEisdsToFlash([...currentEsidsToFlash, saveTradeResponse.esid]);
  }, 50);

  if (setTradeToExpanded) {
    // Add the trade to store array that tells the action summary to expand the trade.
    if (incomingTrade.esid) {
      tradeDataStore.getState().updateEsidsToExpand(incomingTrade.esid);
    }
  }

  addTradeToStore(incomingTrade);

  setTimeout(() => {
    // This timeout is required to trigger the MainTable to update, via a UseEffect, in ActionSummaryTable.tsx
    const currentTradeData = tradeDataStore.getState().tradeData;
    const newTradeData = currentTradeData.map((t) => t);
    tradeDataStore.getState().updateTradeData(newTradeData);
  }, 100);

  const responseForRemainingBlocks = await fetchRequestWrapper(
    { url: "/blocks/unassigned" },
    getAccessTokenSilently,
  );

  importBlocksAndAllocationsStore
    .getState()
    .setImportBlocks(responseForRemainingBlocks.blocks);
}

export async function updateBlockAction(modifiedBlock: IImportJsonBlocks) {
  const allBlocks = importBlocksAndAllocationsStore.getState().allBlocks;

  const newBlocks = allBlocks.map((block) =>
    block.id != modifiedBlock.id ? block : modifiedBlock,
  );

  // Flash the updated row (e.g. after an Edit Trade PATCH). Set before the store update, as
  // refreshUnassignedBlocks does, so CreationTable's rowData effect picks it up.
  if (allBlocks.some((block) => block.id == modifiedBlock.id)) {
    importBlocksAndAllocationsStore
      .getState()
      .updateBlockIdsToFlash([modifiedBlock.id]);
  }

  importBlocksAndAllocationsStore.getState().setImportBlocks(newBlocks);
}

// LQC-2254 - re-read the unassigned blocks and flash whatever is new.
//
// This is the ONLY path that can ADD a block to the store: updateBlockAction above
// maps over the existing list, so a block id it has never seen is silently dropped.
// Lifted out of MegaPipe (which still calls it on BlockCancelled) so the Trade From
// Scratch send can use it too - after POST /Trade/Bond the new block exists server
// side, and nothing else would pull it into the Trade Creation grid.
export async function refreshUnassignedBlocks(
  getAccessTokenSilently: Function,
) {
  const blocksFromDB = await fetchRequestWrapper(
    { url: "/blocks/unassigned" },
    getAccessTokenSilently,
  );
  if (!blocksFromDB?.blocks) return;

  const currentIds = new Set(
    importBlocksAndAllocationsStore.getState().allBlocks.map((b) => b.id),
  );
  const newIds = (blocksFromDB.blocks as { id: number }[])
    .map((b) => b.id)
    .filter((id) => !currentIds.has(id));

  if (newIds.length > 0) {
    importBlocksAndAllocationsStore.getState().updateBlockIdsToFlash(newIds);
  }

  importBlocksAndAllocationsStore
    .getState()
    .setImportBlocks(blocksFromDB.blocks);
}
